import { render, staticRenderFns } from "./trashEventItem.vue?vue&type=template&id=1984f48a"
import script from "./trashEventItem.js?vue&type=script&lang=js&external"
export * from "./trashEventItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports